import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       value - string
 * @Param       children - components
 * @Param       onChange - function
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function IncrementDecrement ({ action, handleIncrement, handleDecrement }) {
    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.INCREMENT-DECREMENT.';
    return (
        <>
            <div className="form-element">
                {t(label + 'TITLE')}<br />
                <ButtonGroup size="small" aria-label="small outlined button group">
                    <Button onClick={handleIncrement}>+</Button>
                    <Button>{action.fields.incrementState?.value * 114}px</Button>
                    <Button onClick={handleDecrement}>-</Button>
                </ButtonGroup>
                <input name="incrementState" type="hidden" value={action.fields.incrementState?.value} />
            </div>
            <div className="form-element">
                <strong>{t(label + 'HELP-TEXT')}</strong>
            </div>
        </>
    );
}
export default IncrementDecrement;